import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_IT_TOOLS_REQUEST_SP_LIST_ID");

const expand =
  "expand=fields(select=Title, eDescription, eContent, eFileContent, eDeptHeadComment, eITLeadComment, eITHeadComment, eAssigneeComment, eApprovedBy, eApprovedDate,eApprovedStatus, eApprovedByITLead,eApprovedByITLeadStatus, eApprovedByITLeadDate,eApprovedByITHead ,eApprovedByITHeadStatus, eApprovedByITHeadDate, eAssignee,eAssigneeStatus,eAssigneeStatusDate, eRequestStatus, eRequestType, eToolId, eToolTypeId, eDepartment, eUnit, eUnion, eComments, ePhoneNumber, ePins)";
export class ITToolRequestService {
  static async getITToolRequests(email: string, status?: string) {
    if (email.toLowerCase() === 'thiennv@viags.vn' || email.toLowerCase() === 'namdh@viags.vn' || email.toLowerCase() === 'trungdt@viags.vn' || email.toLowerCase() === 'hieppt@viags.vn' || email.toLowerCase() === 'botit@viags.vn'
    || email.toLowerCase() === 'tienhc@viags.vn' || email.toLowerCase() === 'huyth@viags.vn' || email.toLowerCase() === 'datnt@viags.vn' || email.toLowerCase() === 'sonnhong@viags.vn' || email.toLowerCase() === 'taidv@viags.vn' || email.toLowerCase() === 'thuonghh@viags.vn'
    || email.toLowerCase() === 'luubd@viags.vn' || email.toLowerCase() === 'nghitc@viags.vn' || email.toLowerCase() === 'phuocvd@viags.vn' || email.toLowerCase() === 'phuocnh@viags.vn' || email?.toLowerCase() === "duydd@viags.vn" ){
      return api
        .get(
          getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`)
        )
        .then((res) => res.data.value)
        .catch((err) => {
          throw new RequestError(err);
        });
    }else{
        let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
        return api
        .get(
          getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}&$top=1000`)
        )
        .then((res) => res.data.value)
        .catch((err) => {
          throw new RequestError(err);
        });
    }
  }

  static async getITToolRequestsApprovalHistory(email: string) {
    let filter = `filter=(startswith(fields/eApprovedBy,'${email.toLowerCase()}') or startswith(fields/eApprovedByITLead,'${email.toLowerCase()}') or startswith(fields/eApprovedByITHead,'${email.toLowerCase()}') or startswith(fields/eAssignee,'${email.toLowerCase()}'))`;
    return api
      .get(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&${filter}`)
      )
      .then((res) => res.data.value)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getMyITToolRequests(email: string) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$top=1000`))
      .then((res) =>
        res.data.value.filter(
          (o: any) =>
            o.createdBy.user.email.toLowerCase() === email.toLowerCase()
        )
      )
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getITToolRequest(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
  static async getCodeVms(id: any) {
    return api
      .get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}?${expand}`))
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }
  static async addITToolRequest(leaveRequest: any) {
    return api
      .post(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`), leaveRequest)
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async updateITToolRequest(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async deleteITToolRequest(id: any) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getHistory(id: any){
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/versions`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }
}
